import { render, staticRenderFns } from "./SyntaxError.vue?vue&type=template&id=552b9dcd&scoped=true"
import script from "./SyntaxError.vue?vue&type=script&lang=js"
export * from "./SyntaxError.vue?vue&type=script&lang=js"
import style0 from "./SyntaxError.vue?vue&type=style&index=0&id=552b9dcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552b9dcd",
  null
  
)

export default component.exports